import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
import { getStorageUser } from '../../../helpers/api_helper';
import { resourcesFiles } from '../../../helpers/backend_helper';

const Columns = ( addUpd, destroy) => {
	const authUser = getStorageUser();
/*
	if (authUser.id != row.administrator_id) {
		let admin_name = {
			id: 'admin_name',
			name: 'Administrador',
			selector: row => row.admin_name,
			sortable: true,
			wrap: true,
			width:'40%'
		}
	}else{

	}
*/
	const getFiles = (id) =>{
		let params={params:{relation:'operator',id:id,field:'operator_id'}}
		resourcesFiles('get',params).then(response => {
        	setModalFile({show:true,id:id,items:response.files});
        })
	}

	let columns = [
		{
			id: 'code',
			name: 'Clave',
			selector: row => row.code,
			sortable: true,
		},
		{
			id: 'name',
			name: 'Nombre',
			selector: row => row.full_name,
			sortable: true,
		},
		{
			id: 'category',
			name: 'Categoría',
			selector: row => row.category,
			sortable: true,
		},
		{
			id: "phone_validated",
			name: "Teléfono validado",
			selector: (row) => row.phone_validated ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-secondary"></i>,
			width: "150px",
			center: true,
		},
		{
			id: 'actions',
			name: 'Acciones',
			width:'20%',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					
					<div className="pe-2">
						<button className="btn btn-primary btn-sm" title='Editar operador' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
					</div>
					<div className="pe-2">
						<button className="btn btn-danger btn-sm" title='Eliminar operador' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
					</div>
				</div>
				),
		}
	];

	if (authUser.profile_id == 2) {
		columns = [
		  {
			id: "ruta",
			name: "Ruta",
			selector: (row) => row.route.name,
			sortable: true,
		  },
		  ...columns,
		];
	  }


	return columns;
}

export default Columns;